import { render, staticRenderFns } from "./OriginalWaste.vue?vue&type=template&id=64613e45&"
import script from "./OriginalWaste.vue?vue&type=script&lang=js&"
export * from "./OriginalWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports